module.exports = require('./helpers/bundle-url').getBundleURL('lABAT') + "logo.c51670a8.svg";